$(document).ready(function(){

	// -- Open Searchbar --
	$('.btn--search').on('click', function(){
		$('.searchbar').addClass('open');
	});

	// -- Close Searchbar --
	$('.searchbar .btn--close').on('click', function(){
		$('.searchbar').removeClass('open');
	});

	$(document).on('mouseup', function(e) {
	  var container = $('.searchbar');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.searchbar').removeClass('open');
	  }
	});
	
});